import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'disabledFileRequestMessage'
  | 'disabledFormMessage'
  | 'disabledFormTitle';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  disabledFileRequestMessage: {
    id: 'boxFileRequest.disabledFileRequest.message',
    description: 'Message for disabled/deleted file requests',
    defaultMessage:
      'This page is unavailable or no longer accepting submissions.',
  },
  disabledFormMessage: {
    id: 'boxFileRequest.disabledForm.message',
    description: 'Message for disabled/deleted forms',
    defaultMessage:
      'This form is unavailable or is no longer accepting submissions. If you think this is a mistake, please reach out to the owner of this form.',
  },
  disabledFormTitle: {
    id: 'boxFileRequest.disabledForm.title',
    description: 'Title for disabled form',
    defaultMessage: `Couldn't access form`,
  },
});

export default messages;
